module.exports = __webpack_public_path__ + "static/media/Tower_Silverchest_opening_MobileV2_compressed.3f516ea5.mp4";